import ParcelTemplate, { CarrierParcelTemplate } from '~/types/ParcelTemplate';
import { ActionKeys } from './constants';

export function fetchParcelTemplates() {
  return <const>{
    type: ActionKeys.PARCEL_TEMPLATE_FETCH,
  };
}

export type FetchParcelTemplatesSuccessPayload = {
  parcelTemplates: ParcelTemplate[];
};

// TODO: Remove payload type and pass parcelTemplates directly to functions
export function fetchParcelTemplatesSuccess(payload: FetchParcelTemplatesSuccessPayload) {
  return <const>{
    payload,
    type: ActionKeys.PARCEL_TEMPLATE_FETCH_SUCCESS,
  };
}

export function fetchParcelTemplateError() {
  return <const>{
    type: ActionKeys.PARCEL_TEMPLATE_FETCH_ERROR,
  };
}

export function fetchCarrierParcelTemplates() {
  return <const>{
    type: ActionKeys.CARRIER_PARCEL_TEMPLATE_FETCH,
  };
}

export type FetchCarrierParcelTemplatesSuccessPayload = {
  carrierParcelTemplates: { [key: string]: CarrierParcelTemplate[] };
};

// TODO: Remove payload type and pass carrierParcelTemplates directly to functions
export function fetchCarrierParcelTemplatesSuccess(
  payload: FetchCarrierParcelTemplatesSuccessPayload,
) {
  return <const>{
    payload,
    type: ActionKeys.CARRIER_PARCEL_TEMPLATE_FETCH_SUCCESS,
  };
}

export function fetchCarrierParcelTemplateError() {
  return <const>{
    type: ActionKeys.CARRIER_PARCEL_TEMPLATE_FETCH_ERROR,
  };
}

export type ParcelTemplateActions =
  | ReturnType<typeof fetchParcelTemplates>
  | ReturnType<typeof fetchParcelTemplatesSuccess>
  | ReturnType<typeof fetchParcelTemplateError>
  | ReturnType<typeof fetchCarrierParcelTemplates>
  | ReturnType<typeof fetchCarrierParcelTemplatesSuccess>
  | ReturnType<typeof fetchCarrierParcelTemplateError>;
